import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './reducers'
import {getReduxMiddleware as getLoggerReduxMiddleware} from './logger';

export default function configureStore(preloadedState) {
  return createStore(
    rootReducer,
    preloadedState,
    compose(applyMiddleware(thunkMiddleware), getLoggerReduxMiddleware())
  )
}
